export default __webpack_public_path__ + "static/media/googleLogo.acbfb665.png";